/* eslint-disable */

// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { depot } from "../../../../api/Api";

export const getAllDepot = createAsyncThunk(
  "appDepot/getAllDepot",
  async (query) => {
    try {
      return depot.getAll(query);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getAllDepotForFilter = createAsyncThunk(
  "appDepot/getAllDepotForFilter",
  async (query) => {
    try {
      return depot.getAllDepot(query);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getDepot = createAsyncThunk("appDepot/getDepot", async (id) => {
  try {
    return depot.getDepot(id);
  } catch (error) {
    console.error(error);
  }
});

export const addDepot = createAsyncThunk(
  "appDepot/addDepot",
  async (values) => {
    try {
      return depot.create(values);
    } catch (error) {
      console.error(error);
    }
  }
);
export const editDepot = createAsyncThunk(
  "appDepot/editDepot",
  async (values) => {
    try {
      return depot.edit(values);
    } catch (error) {
      console.error(error);
    }
  }
);

export const deleteDepot = createAsyncThunk(
  "appDepot/deleteDepot",
  async (id) => {
    return depot.remove(id);
  }
);

export const deleteTransportationPricing = createAsyncThunk(
  "appDepot/deleteTransportationPricing",
  async (id) => {
    return depot.removeTransportationPricing(id);
  }
);

export const addTransportationPricing = createAsyncThunk(
  "appDepot/addTransportationPricing",
  async (values) => {
    return depot.addTransportationPricing(values);
  }
);

export const appDepotSlice = createSlice({
  name: "appDepot",
  initialState: {
    depot: [],
    depotForFilter: [],
    metaData: {},
    depotFetched: false,
    depotForFilterFetched: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllDepot.fulfilled, (state, action) => {
        if (action.payload.status !== 200) {
          state.depot = [];
          state.metaData = {};
          state.depotFetched = false;
          return;
        }
        state.metaData = action.payload?.data?.metaData;
        state.depot = action.payload?.data?.data;
        state.depotFetched = true;
      })
      .addCase(getAllDepotForFilter.fulfilled, (state, action) => {
        if (action.payload.status !== 200) {
          state.depotForFilter = [];
          state.depotForFilterFetched = false;
          return;
        }
        state.depotForFilter = action.payload?.data?.data;
        state.depotForFilterFetched = true;
      })

      .addCase(deleteDepot.fulfilled, (state, action) => {
        state.depotFetched = false;
      })
      .addCase(editDepot.fulfilled, (state, action) => {
        state.depotFetched = false;
      })
      .addCase(addDepot.fulfilled, (state, action) => {
        state.depotFetched = false;
      });
  },
});

export default appDepotSlice.reducer;
